function hide(){
    fitmix.style.display= 'none';
}

function show(){
    fitmix.style.display= 'block';
}

function openVto(){

    //open the "zoom" component
    fitmixInstance.startVto('live')
    show()
}

function stopVto(){
    fitmixInstance.stopVto()
}

window.onload = function() {
    const vtoModule = document.querySelector('#fittingBoxVto');

    var params = {
        apiKey: vtoModule.dataset.key,
        frame: vtoModule.dataset.product,
        onStopVto: hide,
        onIssue : (data) => {
            console.log(data);
        },
    };

    window.fitmixInstance = FitMix.createWidget('fitmix-container', params, function() {
        console.log('VTO module is ready.');
        // console.log('Starting with params:')
        // console.table(params);
        const vtoButton = document.querySelector('.vto-copy-container-loading');
        vtoButton.classList.remove('vto-copy-container-loading');
        vtoButton.classList.add('vto-copy-container');
    });
}
